import { render, staticRenderFns } from "./Loandetails.vue?vue&type=template&id=b63f4b2a&scoped=true"
import script from "./Loandetails.vue?vue&type=script&lang=js"
export * from "./Loandetails.vue?vue&type=script&lang=js"
import style0 from "./Loandetails.vue?vue&type=style&index=0&id=b63f4b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63f4b2a",
  null
  
)

export default component.exports